import {WebToAppCtaImageRequestParams} from "./web-to-app-cta.image.request-params";

export class WebToAppCtaStarImageRequestParams extends WebToAppCtaImageRequestParams {
  constructor(width: Number,height: Number) {
    super(width, height);

    this.resourceName = `${this.resourceName}/Star`;
  }
}
